import { createChart } from "bi-sdk";
export const setBarStatisticsRanking = function (chartData, chartId) {
  let chart = createChart(
    {
      dataset: chartData,
      legend: {
        show: false
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none"
        },
        formatter(params) {
          return `
          <div class="tooltip-foomatter">
            <div class="date">${params[0].axisValue}</div>
            ${params
              .map((item, index) => {
                return `
                  <div class="item"><div class="icon" style="background-color:${
                    item.color
                  }"></div>${item.seriesName}：
                  ${item.value[index + 1]}</div>
              `;
              })
              .join("")}
            </div>
          `;
        }
      },
      grid: {
        left: 0,
        right: 50,
        top: 50,
        bottom: 0,
        containLabel: true
      },
      yAxis: {
        type: "value",
        boundaryGap: "20%",
        splitLine: {
          lineStyle: {
            color: "#E5E6EB",
            type: "dashed"
          }
        },
        min: 0,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "#86909C"
        }
      },
      xAxis: {
        boundaryGap: true,
        alignTicks: true,
        value: "11",
        splitLine: {
          show: false
        },
        axisLabel: {
          color: "#86909C",
          rotate: 40,
          margin: 25,
          formatter(value) {
            return value.substring(0, 4);
          }
        },
        axisTick: {
          show: true,
          length: 4,
          lineStyle: {
            color: "#E5E6EB"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#E5E6EB"
          }
        }
      },
      animation: true,
      series: {
        type: "bar",
        name: "调用排行",
        smooth: false,
        showSymbol: false,
        itemStyle: {
          color: "#7983F5"
        },
        lineStyle: {
          width: 2,
          cap: "round"
        },
        emphasis: {
          lineStyle: {
            width: 6
          }
        },
        areaStyle: {
          color: "none"
        }
      }
    },
    { extend: ["title", "xAxis", "yAxis", "tooltip", "grid", "legend"] }
  );
  chart.amount(chartId);
  return chart;
};

export const monitorBar = function (chartData, color, chartId) {
  let chart = createChart(
    {
      title: {
        text: `{a|${chartData}}{b|%}`,
        y: "center",
        x: "center",
        textStyle: {
          fontSize: 36,
          fontWeight: 700,
          fontFamily: "DINBold",
          color: "#1D2129",
          lineHeight: 56,
          rich: {
            b: {
              fontSize: 16,
              fontWeight: 700,
              fontFamily: "DINBold",
              color: "#1D2129"
            }
          }
        }
      },
      polar: {
        radius: ["97", "85"],
        center: ["50%", "50%"]
      },
      angleAxis: {
        max: 100,
        show: false
      },
      radiusAxis: {
        type: "category",
        show: true,
        axisLabel: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        }
      },
      series: [
        {
          name: "",
          type: "bar",
          roundCap: false,
          barWidth: 180,
          showBackground: true,
          backgroundStyle: {
            color: "#F2F3F5"
          },
          data: [chartData],
          coordinateSystem: "polar",
          itemStyle: {
            color,
            label: {
              show: false
            },
            borderCap: "butt"
          }
        }
      ]
    },
    { extend: [] }
  );
  chart.amount(chartId);
  return chart;
};

export const setRateBar = function (value, name, subtext, color, chartId) {
  let titTop = "center";
  if (name) {
    titTop = "15%";
  }
  if (name && subtext) {
    titTop = "22%";
  }
  let chart = createChart(
    {
      title: [
        {
          text: `{a|${value}}{b|%}`,
          left: "center",
          top: titTop,
          itemGap: -14,
          textStyle: {
            fontSize: 20,
            fontWeight: "bold",
            color: "#1D2129",
            lineHeight: 56,
            rich: {
              b: {
                fontSize: 14,
                color: "#1D2129"
              }
            }
          },
          subtext: name ? name : "",
          subtextStyle: {
            color: "#86909C",
            fontSize: 12
          }
        },
        {
          text: subtext,
          top: "20%",
          left: "center",
          textStyle: {
            color: "#C9CDD4",
            fontSize: 12
          }
        }
      ],
      polar: {
        radius: ["92%", "100%"],
        center: ["50%", "50%"]
      },
      angleAxis: {
        max: 100,
        show: false
      },
      radiusAxis: {
        type: "category",
        show: true,
        axisLabel: {
          show: false
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        }
      },
      series: [
        {
          name: "",
          type: "bar",
          axisLine: {
            roundCap: false
          },
          barWidth: 180,
          showBackground: true,
          backgroundStyle: {
            color: "#F2F3F5"
          },
          data: [value],
          coordinateSystem: "polar",
          itemStyle: {
            color,
            label: {
              show: false
            }
          }
        }
      ]
    },
    { extend: [] }
  );
  chart.amount(chartId);
  return chart;
};

export const setBar = function (chartData, chartId) {
  let chart = createChart(
    {
      dataset: chartData,
      grid: {
        top: 42,
        bottom: 60
      },
      xAxis: {
        silent: false,
        axisLabel: {
          color: "#86909C"
        },
        splitLine: {
          show: false
        },
        splitArea: {
          show: false
        }
      },
      yAxis: {
        axisLabel: {
          color: "#86909C"
        },
        axisLine: {
          show: false
        },
        splitArea: {
          show: false
        }
      },
      dataZoom: [
        {
          type: "inside"
        },
        {
          type: "slider",
          bottom: 7,
          height: 20,
          dataBackground: {
            lineStyle: {
              width: 1,
              color: "#CCF7EB"
            },
            areaStyle: {
              color: "#E8FFF8"
            }
          },
          fillerColor: "rgba(204, 247, 235, 0.5)",
          borderColor: "#B2EFE0",
          moveHandleSize: 6,
          moveHandleStyle: {
            color: "#B2EFE0",
            borderWidth: 0
          },
          emphasis: {
            moveHandleStyle: {
              color: "#B2EFE0"
            }
          }
        }
      ],
      series: [
        {
          type: "bar",
          itemStyle: {
            color: "#6AD6C7"
          }
        }
      ]
    },
    {
      extend: ["title", "xAxis", "yAxis"],
      theme: {}
    } // extend内容会使用默认配置
  );
  // chart.dataSet(chartData);
  chart.amount(chartId);
  return chart;
};

export const setBorderRadiusBar = (chartData, chartId, unit) => {
  const chart = createChart(
    {
      dataset: chartData,
      grid: {
        top: 16,
        left: 0,
        right: 30,
        bottom: 24,
        containLabel: true
      },
      xAxis: {
        splitLine: {
          show: false
        },
        axisLabel: {
          color: "#A9B0B9"
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      },
      legend: {
        show: false
      },
      yAxis: {
        axisLine: {
          show: false
        },
        splitLine: {
          lineStyle: {
            color: "#E5E6EB"
          }
        },
        axisLabel: {
          color: "#A9B0B9",
          formatter: unit ? "{value}" + unit : "{value}"
        }
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none"
        },
        formatter(params) {
          return `
          <div class="tooltip-foomatter">
            <div class="date">${params[0].axisValue}</div>
            ${params
              .map((item, index) => {
                return `
                  <div class="item"><div class="icon" style="background-color:${
                    item.color
                  }"></div>${item.seriesName}：
                  ${item.value[index + 1]}${index == 1 ? "%" : ""}</div>
              `;
              })
              .join("")}
            </div>
          `;
        }
      },
      series: {
        name: "实际发电量",
        type: "bar",
        barWidth: "6px",
        itemStyle: {
          color: "#6AD6C7",
          borderRadius: [4, 4, 0, 0]
        }
      }
    },
    { extend: ["xAxis", "yAxis", "tooltip", "grid"] }
  );
  chart.amount(chartId);
  return chart;
};

export const setBarPowerSave = (chartData, chartId) => {
  const chart = createChart(
    {
      dataset: chartData,
      grid: {
        top: 56,
        left: 50,
        right: 30,
        bottom: 24
      },
      xAxis: {
        splitLine: {
          show: false
        },
        axisLabel: {
          color: "#86909C"
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      },
      legend: {
        show: true,
        itemGap: 16,
        textStyle: {
          color: "#778493",
          fontSize: 12,
          lineHeight: 18
        },
        icon: "circle",
        itemWidth: 6,
        itemHeight: 6,
        right: 0,
        top: 0
      },
      yAxis: {
        axisLine: {
          show: false
        },
        splitLine: {
          lineStyle: {
            color: "#E5E6EB"
          }
        },
        axisLabel: {
          color: "#86909C"
        }
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none"
        },
        formatter(params) {
          return `
          <div class="tooltip-foomatter">
            <div class="date">${params[0].axisValue}</div>
            ${params
              .map((item, index) => {
                return `
                  <div class="item"><div class="icon" style="background-color:${
                    item.color
                  }"></div>${item.seriesName}：
                  ${item.value[index + 1]}${index == 1 ? "%" : ""}</div>
              `;
              })
              .join("")}
            </div>
          `;
        }
      },
      series: [
        {
          name: "节能量",
          type: "bar",
          barWidth: 16,
          itemStyle: {
            color: "rgba(121,131,245,0.73)"
          }
        },
        {
          name: "用能量",
          type: "bar",
          barGap: 0,
          barWidth: 16,
          itemStyle: {
            color: "rgba(106,214,199,0.73)"
          }
        },
        {
          name: "基准值量",
          type: "line",
          smooth: true,
          itemStyle: {
            color: "#FDBE71",
            width: 2
          },
          symbolSize: 0,
          areaStyle: {
            opacity: 0
          }
        }
      ]
    },
    { extend: ["xAxis", "yAxis", "tooltip", "grid"] }
  );
  chart.amount(chartId);
  return chart;
};

export const setBarBackip = (chartData, chartId) => {
  const chart = createChart(
    {
      dataset: chartData,
      grid: {
        top: 56,
        left: 50,
        right: 50,
        bottom: 24
      },
      xAxis: {
        boundaryGap: false,
        splitLine: {
          show: false
        },
        axisLabel: {
          color: "#86909C"
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      },
      legend: {
        show: true,
        itemGap: 16,
        itemWidth: 10,
        itemHeight: 1
      },
      yAxis: [
        {
          type: "value",
          splitLine: {
            lineStyle: {
              color: "#E5E6EB",
              type: "dashed"
            }
          },
          max: 1000,
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#86909C"
          }
        },
        {
          type: "value",
          position: "right",
          max: 100,
          splitLine: {
            lineStyle: {
              color: "#E5E6EB"
            }
          },
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#86909C"
          }
        }
      ],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none"
        },
        formatter(params) {
          return `
          <div class="tooltip-foomatter">
            <div class="date">${params[0].axisValue}</div>
            ${params
              .map((item, index) => {
                return `
                  <div class="item"><div class="icon" style="background-color:${
                    item.color
                  }"></div>${item.seriesName}：
                  ${item.value[index + 1]}${index == 1 ? "%" : ""}</div>
              `;
              })
              .join("")}
            </div>
          `;
        }
      },
      series: [
        {
          name: "文件数量",
          type: "line",
          yAxisIndex: 0,
          smooth: false,
          itemStyle: {
            color: "#55D46C",
            width: 2
          },
          symbolSize: 0,
          areaStyle: {
            opacity: 0
          }
        },
        {
          name: "文件大小",
          type: "bar",
          legendHoverLink: true,
          yAxisIndex: 1,
          barWidth: 24,
          itemStyle: {
            color: "#7983F5"
          }
        }
      ]
    },
    { extend: ["xAxis", "yAxis", "tooltip", "grid"] }
  );
  chart.amount(chartId);
  return chart;
};

export const setBarAuditOverview = function (chartData, chartId) {
  let chart = createChart(
    {
      dataset: chartData,
      legend: {
        data: ["本地审计", "云端审计"],
        left: "center",
        itemWidth: 10,
        itemHeight: 7
      },
      grid: {
        left: 0,
        right: 50,
        top: 50,
        bottom: 0,
        containLabel: true
      },
      yAxis: {
        type: "value",
        boundaryGap: "20%",
        splitLine: {
          lineStyle: {
            color: "#E5E6EB",
            type: "dashed"
          }
        },
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "#86909C"
        }
      },
      xAxis: {
        boundaryGap: true,
        alignTicks: true,
        splitLine: {
          show: false
        },
        axisLabel: {
          color: "#86909C"
        },
        axisTick: {
          show: true,
          length: 4,
          lineStyle: {
            color: "#E5E6EB"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#E5E6EB"
          }
        }
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none"
        },
        formatter(params) {
          return `
          <div class="tooltip-foomatter">
            <div class="date">${params[0].axisValue}</div>
            ${params
              .map((item, index) => {
                return `
                  <div class="item"><div class="icon" style="background-color:${
                    item.color
                  }"></div>${item.seriesName}：
                  ${item.value[index + 1]}${index == 1 ? "%" : ""}</div>
              `;
              })
              .join("")}
            </div>
          `;
        }
      },
      animation: true,
      series: [
        {
          type: "bar",
          smooth: false,
          showSymbol: false,
          itemStyle: {
            color: "#55D46C"
          },
          lineStyle: {
            width: 2,
            cap: "round"
          },
          emphasis: {
            lineStyle: {
              width: 6
            }
          },
          areaStyle: {
            color: "none"
          }
        },
        {
          type: "bar",
          smooth: false,
          showSymbol: false,
          itemStyle: {
            color: "#7983F5"
          },
          lineStyle: {
            width: 2,
            cap: "round"
          },
          emphasis: {
            lineStyle: {
              width: 6
            }
          },
          areaStyle: {
            color: "none"
          }
        }
      ]
    },
    { extend: ["title", "xAxis", "yAxis", "tooltip", "grid", "legend"] }
  );
  chart.amount(chartId);
  return chart;
};

export const setBarCost = (chartData, chartId) => {
  const chart = createChart(
    {
      dataset: chartData,
      grid: {
        top: 56,
        left: 50,
        right: 30,
        bottom: 24
      },
      xAxis: {
        splitLine: {
          show: false
        },
        axisLabel: {
          color: "#86909C"
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      },
      legend: {
        show: true,
        itemGap: 16,
        textStyle: {
          color: "#778493",
          fontSize: 12,
          lineHeight: 18
        },
        icon: "react",
        itemWidth: 6,
        itemHeight: 6,
        left: "center"
      },
      yAxis: {
        axisLine: {
          show: false
        },
        splitLine: {
          lineStyle: {
            color: "#E5E6EB"
          }
        },
        axisLabel: {
          color: "#86909C"
        }
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none"
        },
        formatter(params) {
          return `
          <div class="tooltip-foomatter">
            <div class="date">${params[0].axisValue}</div>
            ${params
              .map((item, index) => {
                return `
                  <div class="item"><div class="icon" style="background-color:${
                    item.color
                  }"></div>${item.seriesName}：
                  ${item.value[index + 1]}${index == 1 ? "%" : ""}</div>
              `;
              })
              .join("")}
            </div>
          `;
        }
      },
      series: [
        {
          name: "消费金额",
          type: "bar",
          barWidth: 16,
          itemStyle: {
            color: "rgba(121,131,245,0.73)"
          }
        }
      ]
    },
    { extend: ["xAxis", "yAxis", "tooltip", "grid"] }
  );
  chart.amount(chartId);
  return chart;
};

export const setBarInterspaceUsage = function (chartData, chartId) {
  let chart = createChart(
    {
      dataset: chartData,
      legend: {
        show: false
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none"
        },
        formatter(params) {
          return `
          <div class="tooltip-foomatter">
            <div class="date">${params[0].axisValue}</div>
            ${params
              .map((item, index) => {
                return `
                  <div class="item"><div class="icon" style="background-color:${
                    item.color
                  }"></div>${item.seriesName}：
                  ${item.value[index + 1]}</div>
              `;
              })
              .join("")}
            </div>
          `;
        }
      },
      grid: {
        left: 0,
        right: 50,
        top: 50,
        bottom: 0,
        containLabel: true
      },
      yAxis: {
        type: "value",
        boundaryGap: "20%",
        splitLine: {
          lineStyle: {
            color: "#E5E6EB",
            type: "dashed"
          }
        },
        min: 0,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: "#86909C"
        }
      },
      xAxis: {
        boundaryGap: true,
        alignTicks: true,
        value: "11",
        splitLine: {
          show: false
        },
        axisLabel: {
          color: "#86909C"
        },
        axisTick: {
          show: true,
          length: 4,
          lineStyle: {
            color: "#E5E6EB"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#E5E6EB"
          }
        }
      },
      animation: true,
      series: {
        type: "bar",
        name: "调用排行",
        smooth: false,
        showSymbol: false,
        itemStyle: {
          color: "#7983F5"
        },
        lineStyle: {
          width: 2,
          cap: "round"
        },
        emphasis: {
          lineStyle: {
            width: 6
          }
        },
        areaStyle: {
          color: "none"
        }
      }
    },
    { extend: ["title", "xAxis", "yAxis", "tooltip", "grid", "legend"] }
  );
  chart.amount(chartId);
  return chart;
};
